import React from 'react';
import TextField from 'material-ui/TextField';
import { cyan500 } from 'material-ui/styles/colors';
import Checkbox from 'material-ui/Checkbox';

class DiscountInfo extends React.Component {
  render() {
    const { disableFields, styles, discount, handleChange, errorText, defaultChecked } = this.props
    return(
      <div>
          <TextField
            floatingLabelText="ID"
            floatingLabelStyle={styles.floatingLabelStyle}
            inputStyle={styles.inputStyle}
            value={discount.id || ''}
            disabled
          />
          <br />
          <TextField
            floatingLabelText="Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={discount.name || ''}
            name="name"
            onChange={!disableFields ? handleChange : ''}
            style={styles.inputStyle}
            errorText={errorText}
            errorStyle={{ color: cyan500 }}
          />
          <TextField
            floatingLabelText="Minimum Order Amount"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={discount.triggerMinOrderAmt || 0}
            name="triggerMinOrderAmt"
            onChange={!disableFields ? handleChange : ''}
            style={styles.inputStyle}
          />
          <br />
          <br />
          <ul>
            <li>
              <Checkbox
                label="Disabled"
                defaultChecked={defaultChecked}
                name="disabled"
                onCheck={!disableFields ? handleChange : ''}
              />
            </li>
          </ul>
          <br />
      </div>
    )
  }
}

export default (DiscountInfo);


// WEBPACK FOOTER //
// ./src/components/discounts/common/DiscountInfo.js